import React, { useState } from 'react';
import { ContainerFullWidth } from 'components/layouts/ContainerFullWidth';
import { Footer } from 'components/molecules/Footer';
import useStyle from './notAuthorizedEleve.style';
import { Rgpd } from './components/Rgpd';
import { AccountDetails } from './components/Account';
import { AvatarsChoice } from './components/Avatars';
import { IconButton } from 'components/atoms/Buttons/IconButton';
import logout from 'graphql/logout';

const NotAuthorizedEleve = () => {
  const classes = useStyle();
  const [step, setStep] = useState(1);

  return (
    <div className={classes.root}>
      <div className={classes.logout}>
        <IconButton onClick={logout} icon={'Logout'} />
      </div>
      <ContainerFullWidth>
        {step === 1 && <Rgpd next={() => setStep(step + 1)} />}
        {step === 2 && (
          <AccountDetails
            previous={() => setStep(step - 1)}
            next={() => setStep(step + 1)}
          />
        )}
        {step === 3 && <AvatarsChoice previous={() => setStep(step - 1)} />}
      </ContainerFullWidth>
      <Footer shopId={'shop'} isNotAuthorizedEleve={true} />
    </div>
  );
};

export default NotAuthorizedEleve;
